import { motion } from 'framer-motion';

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.25,
      delayChildren: 0.3,
    },
  },
};

const cardVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};

const ProductCard = ({ title, description, src, tags, isFlagship, link }) => (
  <motion.a
    href={link}
    target="_blank"
    rel="noopener noreferrer"
    className="w-full max-w-[300px] xs:max-w-[320px] sm:max-w-[360px] md:max-w-[400px] lg:max-w-[430px] xl:max-w-[470px] min-h-[340px] sm:min-h-[370px] md:min-h-[400px] lg:min-h-[420px] xl:min-h-[450px] bg-white flex-shrink-0 space-y-1 flex flex-col border-[1px] rounded-xl p-4 sm:p-5 md:p-6 xl:p-8 shadow-md z-20 border-[#B7BCC5] hover:cursor-pointer no-underline"
    variants={cardVariants}
    whileHover={{
      scale: 1.005,
      boxShadow: '0 10px 20px rgba(0, 0, 0, 0.08)',
      borderColor: '#9ca3af',
    }}
    transition={{ duration: 0.2, ease: 'easeOut' }}
  >
    {src ? (
      <div className="flex items-center justify-center w-full h-36 sm:h-40 md:h-44 lg:h-48 xl:h-56 rounded-lg border-[1px] overflow-hidden">
        <img
          src={src}
          alt={title}
          className="max-w-[40%] max-h-full object-contain"
        />
      </div>
    ) : (
      <div className="w-full h-36 sm:h-40 md:h-44 lg:h-48 xl:h-56 rounded-lg border-[1px] bg-gray-100 flex items-center justify-center">
        <span className="text-base lg:text-lg text-gray-500 font-semibold">
          No Preview Available
        </span>
      </div>
    )}
    <h1 className="text-base sm:text-lg lg:text-xl font-semibold p-2 pt-3 sm:pt-4 lg:pt-5 flex items-center gap-2 lg:gap-3">
      {title}
      {isFlagship && (
        <motion.span
          className="text-xs lg:text-sm font-normal bg-gray-100 px-2 lg:px-3 py-1 rounded-md text-gray-700"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.5 }}
        >
          Flagship Product
        </motion.span>
      )}
    </h1>
    <p className="text-gray-500 px-2 text-sm lg:text-md hyphens-auto break-words" lang="en">{description}</p>
    <div className="w-full flex flex-wrap gap-1.5 lg:gap-2 px-2 pt-4 lg:pt-6">
      {tags &&
        tags.map((tag, index) => (
          <div
            key={index}
            className="bg-[#0D5192] rounded-xl text-white text-xs lg:text-sm p-1 px-2 lg:px-2.5 whitespace-nowrap"
          >
            {tag}
          </div>
        ))}
    </div>
  </motion.a>
);

function Products() {
  const products = [
    {
      id: 1,
      title: 'PlotStudio AI',
      description:
        'Agentic analytics platform for professionals. Transform your data into actionable insights with autonomous AI.',
      src: '/plotstudio-logo.png',
      tags: [ 'AI Agent', 'Data Analysis', 'Desktop App'],
      isFlagship: true,
      link: 'https://www.plotstudio.ai/',
    },
  ];

  return (
    <section
      id="Products"
      className="font-primary pt-[8vh] pb-[8vh] min-h-screen flex flex-col items-center bg-white"
    >

      <motion.div
        className="text-2xl xs:text-3xl sm:text-3xl md:text-4xl lg:text-4xl xl:text-5xl bg-white p-4 sm:p-6 md:p-8 xl:p-10 z-20 pb-4 sm:pb-6 lg:pb-8"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-100px' }}
        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
      >
        Products
      </motion.div>

      <motion.div
        className="flex gap-4 sm:gap-5 lg:gap-6 flex-wrap justify-center items-center bg-white z-10 p-3 px-4 sm:px-6 w-full max-w-[98%]"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: '-50px' }}
      >
        {products.map((product) => (
          <ProductCard key={product.id} {...product} />
        ))}
      </motion.div>
    </section>
  );
}

export default Products;
